import { Component, input } from '@angular/core';
import { Blog } from '../services/blog.service';
import { RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-blog-list',
  imports: [RouterModule, DatePipe],
  templateUrl: './blog-list.component.html',
  styleUrl: './blog-list.component.scss',
})
export class BlogListComponent {
  blogs = input<Blog[]>([]);
  expandedCategories: { [key: string]: boolean } = {};

  toggleCategories(slug: string) {
    this.expandedCategories[slug] = !this.expandedCategories[slug];
  }

  expandCategories(slug: string) {
    this.expandedCategories[slug] = true;
  }

  collapseCategories(slug: string) {
    this.expandedCategories[slug] = false;
  }

  getTextColor(bgColor: string): string {
    if (!bgColor || !bgColor.startsWith('#')) return '#000000';

    let r = 0,
      g = 0,
      b = 0;
    const hex = bgColor.replace('#', '');

    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    }

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? '#000000' : '#FFFFFF';
  }
}
